import { ValidatePassword, ValidatePasswordMessage } from '@swivl-mono/helpers';
import { Button, ButtonColor, ButtonSize, Input } from '@swivl-mono/ui';
import { useState } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import AccountModel from '../../../Models/Account/AccountModel';
import Logo from '../Assets/SwivlLogo.png';

export function ResetPasswordView() {
  const navigate = useNavigate();

  const params = useParams();

  const [password, setPassword] = useState("chuckchuck1");
  const [password2, setPassword2] = useState("chuckchuck1");
  const [errorMsg, setErrorMsg] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const resetPassword = () => {
    setErrorMsg("");

    if (password !== password2) {
      setErrorMsg("Passwords do not match");
      return;
    }

    var isValidPassword = ValidatePassword(password);
    if (isValidPassword === false) {
      setErrorMsg(ValidatePasswordMessage);
      return;
    }
    if (!params.token) {
      setErrorMsg("Invalid token");
      return;
    }
    setIsLoading(true);

    AccountModel.resetPassword(params.token, password, navigate).catch((error) => {
      setIsLoading(false);
      setErrorMsg("Error resetting password");
    })
  }

  return (<div className="ForgotPasswordView flex flex-col items-center w-full p-20">
    <img src={Logo} alt="Swivl Logo" className="w-1/4 mx-auto mb-8" />
    <div className="container mx-auto">
      <div className="loginContent">
        <h4>Reset Password</h4>

        <label>New Password</label>
        <Input
          size={Input.Size.Large}
          value={password}
          type={Input.Type.Password}
          name="password"
          onSet={setPassword}
          enableAutoComplete={true}
        />
        <label>Repeat Password</label>
        <Input
          size={Input.Size.Large}
          type={Input.Type.Password}
          value={password2}
          name="password2"
          onSet={setPassword2}
          enableAutoComplete={true}
        />
        <Button
          className="mb-5"
          onClick={resetPassword}
          loading={isLoading}
          color={ButtonColor.ORANGE}
          size={ButtonSize.LARGE}
        >
          RESET
        </Button>
        <Link className="backToLogin" to="/login">Back</Link>
      </div>
    </div>
    <div className="text-red-500">{errorMsg}</div>
  </div>
  );
}
